import { render } from "./Jhk.vue?vue&type=template&id=1f725952&scoped=true"
import script from "./Jhk.vue?vue&type=script&lang=js"
export * from "./Jhk.vue?vue&type=script&lang=js"

import "./Jhk.vue?vue&type=style&index=0&id=1f725952&lang=less&scoped=true"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f725952"]])

export default __exports__